import xlsx from 'json-as-xlsx';

export const downloadCSV = (xlsxStructure, filePrefix = '') => {
  try {
    const settings = {
      fileName: `${filePrefix}_${new Date().toISOString().slice(0, 10)}`,
      writeMode: 'writeFile',
    };

    xlsx(xlsxStructure, settings);
  } catch (e) {
    console.error('Erro ao gerar CSV:', e);
  }
};
